import { motion } from "framer-motion";

export default function PageHero({ image, mobileImage, eyebrow, title, accent, subtitle, align="left", heroKey="", children }) {
  return (
    <section className={`page-cinematic-hero hero-${align} ${heroKey ? `page-hero-${heroKey}` : ""}`}>
      <picture className="page-cinematic-picture">
        {mobileImage && <source media="(max-width: 760px)" srcSet={mobileImage} />}
        <img src={image} alt="" className="page-cinematic-bg" fetchPriority="high" decoding="async" />
      </picture>
      <div className="page-cinematic-shade" />
      <motion.div className="page-cinematic-copy" initial={{opacity:0,y:28}} animate={{opacity:1,y:0}} transition={{duration:.85}}>
        <span className="page-hero-eyebrow">{eyebrow}</span>
        <h1>{title} {accent && <em>{accent}</em>}</h1>
        {subtitle && <p>{subtitle}</p>}
        {children}
      </motion.div>
      <div className="page-hero-scroll"><span/> SCROLL TO DISCOVER</div>
    </section>
  );
}
